<template>
  <div id="LandingConfirmClient" class="row">
    <div class="overlay"></div>

    <div class="modal ConfirmClient">
      <div style="display: flex; margin-bottom: 25px;">
      <img
              src="/biat_logo_simple.png"
              style="width: 40px; margin-right: 15px;"
              alt=""
            />
      <span class="ConfirmAccount">{{ $t("WelcomeTo") }} {{ businessName }} </span>
      </div>

      <div class="group">
        
        <b>{{ "Nous voulons juste savoir si vous êtes un client chez BIAT ou non" }}</b>
        </div>

      <div class="footer">
        <button class="btn">
          {{ "Oui" }}
        </button>
        <button class="btn" style="background-color: #fff; border-color: var(--primary); color: var(--primary);">
          {{ "Non" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { config } from "bluebird";
import $ from "jquery";
import { userService } from "/src/_services";
var Config = require("@config");

export default {
  data: () => ({
    lang: localStorage.getItem("Language"),
    loading: false,
    terms: false,
    error_edit: false,
    checkTerms: false,
    checkName: false,
    checkEmail: false,
    businessName: ""
  }),
  props: {
    user: Object,
  },
  mounted() {
    if (this.lang == "ar") {
      document.getElementById("termsNcond").dir = "rtl";
    }
    this.businessName = Config.organization_name;
  },
  methods: {
    editProfile() {
      if (this.terms) {
        this.error_edit = false;
        let data = new FormData();

        data.append("fullname", this.user.fullname);
        data.append("email", this.user.email);
        data.append(
          "social_reason",
          this.user.social_reason ? this.user.social_reason : ""
        );
        data.append("_method", "PUT");

        if (this.user.fullname.length <= 1) {
          this.checkName = true;
          return;
        } else {
          this.checkName = false;
        }
        if (!this.user.email) {
          this.checkEmail = true;
          return;
        } else {
          this.checkEmail = false;
        }
        this.loading = true;
        userService
          .update(data)
          .then(
            function (data) {
              let actualUser = JSON.parse(localStorage.getItem("user"));
              actualUser.fullname = data.user.fullname;
              actualUser.email = data.user.email;
              actualUser.social_reason = data.user.social_reason;
              localStorage.setItem("user", JSON.stringify(actualUser));
              this.user = actualUser;
              $("#code1").focus();
              setTimeout(function () {
                $("#code1").focus();
              }, 300);
            }.bind(this)
          )
          .catch(
            function () {
              this.error_edit = true;
            }.bind(this)
          )
          .finally(
            function () {
              this.loading = false;
              location.replace("/");
            }.bind(this)
          );
      } else {
        this.checkTerms = true;
      }
    },
    show() {
      $("#LandingConfirmClient").fadeIn("300");
    },
    hide() {
      $("#LandingConfirmClient").fadeOut("300", function () {
        $(".ConfirmClient").fadeIn();
        $(".RegisterModal").fadeOut();
        $(".VerifyModal").fadeOut();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ConfirmAccount {
  font-size: 18px;
  font-weight: 900;
  width: 100%;
  display: flex;
  margin: auto;
  justify-content: center;
  color: var(--primary);
}
#LandingConfirmClient {
  width: 100vw;
  height: 100vh;
  min-height: -webkit-fill-available;
  overflow-x: hidden !important;
  overflow-y: hidden !important;
  position: absolute;
  top: 50%;
  margin: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999999990;

  display: none;
  .overlay {
    width: 100vw;
    height: 100vh;
    min-height: -webkit-fill-available;
    z-index: 9999999999991;
    cursor: pointer;
    background: rgba($color: #000000, $alpha: 0.3);
  }
  .modal {
    width: 35%;
    height: auto;
    min-width: 320px;
    background: #fff;
    z-index: 992;
    border-radius: 25px;
    padding: 25px 50px;

    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .Verify {
      margin-top: 20px;
      .code {
        display: flex;
        justify-content: center;
        input {
          margin-left: 10px;
          margin-right: 10px;
          height: 50px;
          width: 50px;
          border: 1px solid var(--primary);
          color: var(--primary);
          border-radius: 5px;
          text-align: center;
          font-size: 15px;
        }
      }
    }
    .group {
      b {
        font-size: 13px;
        font-size: 900;
        margin-bottom: 10px;
        display: block;
      }
      input {
        width: 100%;
        height: 40px;
        padding: 0 20px;
        border: 1px solid #ccc;
        border-radius: 5px;
        font-size: 14px;
        letter-spacing: 1px;
      }
    }
    .footer {
      text-align: center;
      margin-top: 10px;
      .text {
        color: #555;
        font-size: 14px;
      }
      button {
        background: var(--primary);
        color: var(--primary-font);
        padding: 10px 35px;
        border-radius: 100px;
        letter-spacing: 1px;
        margin: 10px 15px;
        font-size: 15px;
      }
      button:hover {
        background: var(--primary-hover);
      }
    }
  }
  .RegisterModal {
    display: none;
  }
  @media only screen and (max-width: 800px) {
    .modal {
      padding: 20px 25px;
      .Verify {
        .code {
          input {
            width: 40px;
            height: 40px;
            margin-left: 5px;
            margin-right: 5px;
          }
        }
      }
    }
  }
}
</style>